import styles from './DefaultBrandLogo.module.scss';

/**
 * NOL brand logo — inline SVG, zero external dependency.
 *
 * `@yanolja-rnd/nol-icons` 의 `IcBrandLogo` (ic_brand_logo.svg) 를 소스 레벨로 복사.
 * brand asset 은 드물게 변경되며, 외부 패키지/URL 의존을 끊어 SSR 첫 paint 부터 즉시 노출 (HTTP RT 0).
 *
 * 색상: `currentColor` — 호스트가 `color` style 로 theme 제어 (예: 흰색 헤더 vs 다크 헤더).
 * 원본 brand color (`#4154FF`) 가 default 라면 호스트가 wrapping element 에 `style={{ color: '#4154FF' }}` 명시.
 */
export function DefaultBrandLogo() {
  return (
    <svg aria-hidden="true" className={styles.logo} fill="none" viewBox="0 0 164 60" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M88.405 0C71.8633 0 58.405 13.4583 58.405 30C58.405 46.5417 71.8633 60 88.405 60C104.947 60 118.405 46.5417 118.405 30C118.405 13.4583 104.95 0 88.405 0ZM88.405 47.2464C78.8968 47.2464 71.1586 39.5115 71.1586 30C71.1586 20.4885 78.8935 12.7536 88.405 12.7536C97.9164 12.7536 105.651 20.4885 105.651 30C105.651 39.5115 97.9164 47.2464 88.405 47.2464Z"
        fill="currentColor"
      />
      <path
        d="M40.9799 32.4283L29.4603 10.0309C26.2909 4.1255 19.7867 1.25055 13.2792 2.88156C6.76843 4.51257 2.39481 10.1136 2.39481 16.813V55.9936C2.39481 56.4865 2.79511 56.8869 3.28806 56.8869H14.1493C14.6423 56.8869 15.0426 56.4865 15.0426 55.9936V16.9718C15.0426 16.6376 15.0426 15.4599 16.3593 15.129C17.6727 14.7982 18.2781 15.8999 18.4369 16.1943L39.8551 55.9506C40.1661 56.5296 40.7682 56.8902 41.4266 56.8902H52.6683C53.1612 56.8902 53.5615 56.4899 53.5615 55.9969V4.01301C53.5615 3.52007 53.1612 3.11976 52.6683 3.11976H41.8765C41.3836 3.11976 40.9832 3.52007 40.9832 4.01301V32.4283H40.9799Z"
        fill="currentColor"
      />
      <path
        d="M142.787 44.0505C139.082 44.0505 136.078 41.0465 136.078 37.3412V4.0064C136.078 3.51345 135.678 3.11315 135.185 3.11315H124.095C123.602 3.11315 123.202 3.51345 123.202 4.0064V38.0492C123.202 48.4539 131.635 56.8869 142.04 56.8869H160.712C161.205 56.8869 161.605 56.4865 161.605 55.9936V44.9404C161.605 44.4475 161.205 44.0472 160.712 44.0472H142.784L142.787 44.0505Z"
        fill="currentColor"
      />
    </svg>
  );
}

DefaultBrandLogo.displayName = 'DefaultBrandLogo';
